import { render, staticRenderFns } from "./audio.vue?vue&type=template&id=0af3f73a&scoped=true&"
import script from "./audio.vue?vue&type=script&lang=js&"
export * from "./audio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0af3f73a",
  null
  
)

export default component.exports